import React from 'react';

import { cn } from '@/services/utils';

const DialogFooter = ({
    className,
    children,
    ...props
}: React.HTMLAttributes<HTMLDivElement> & { children?: React.ReactNode }) => {
    const childCount = React.Children.toArray(children).length;

    return (
        <div
            className={cn(
                `tw-flex
                 tw-flex-col-reverse
                 tw-flex-shrink-0
                 tw-py-3
                 tw-px-5
                 lg:tw-px-8
                 sm:tw-flex-row
                 sm:tw-space-x-2
                 tw-border-l-0
                 tw-border-r-0
                 tw-border-b-0
                 tw-border-t-1
                 tw-border-solid
                 tw-border-divider`,
                childCount <= 2 ? 'sm:tw-justify-end' : 'sm:tw-justify-between',
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
};

DialogFooter.displayName = 'DialogFooter';

export { DialogFooter };
